import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";
import ImgsViewer from "react-images-viewer";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { code, idx } = useParams();
    const { site, iam } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [view, setView] = useState(-1);

    const getNavigation = () => {
        switch (code) {
            case "notice":
                return site?.naviBbsNotice;
            case "pds":
                return site?.naviBbsPds;
            case "photo":
                return site?.naviBbsPhoto;
        }
    };

    const getTitle = () => {
        switch (code) {
            case "notice":
                return "Notice";
            case "pds":
                return "Download Center";
            case "photo":
                return "Photo Gallery";
        }
    };

    const loadData = () => {
        _API.get({ path: "/site/bbs/item", data: { idx } })
            .then((res) => {
                const { data, fileList } = res.data;
                setData(data);
                setFileList(fileList);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    useEffect(() => {
        if (site?.siteCode && idx) {
            loadData();
        }
    }, [site, idx]);

    const getImageList = () => {
        let list = fileList?.filter((m) => m.fileType === "PHOTO");
        list = list.map((img) => {
            return { src: img?.signedUrl };
        });

        return list;
    };

    const onImageView = (index) => {
        setView(index);
    };

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {getNavigation() && parse(getNavigation())}

                <div className="right">
                    <div className="contentsTop">
                        <h3>{getTitle()}</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>{getTitle()}</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <table className="tbl tbl_view">
                            <tbody>
                                <tr>
                                    <th>
                                        <strong>{data?.title}</strong>
                                        By {data?.writerName} / {moment(data?.regDate).format("YYYY-MM-DD HH:mm")} / Hits : {_U.addComma(data?.hit)}
                                    </th>
                                </tr>
                                <tr>
                                    <td className="box_editor box_img m_scrollBox">
                                        {data?.code === "photo" && getImageList()?.length > 0 && (
                                            <>
                                                <div className="popup-gallery">
                                                    {getImageList()?.map((image, index) => (
                                                        <a href={void 0} onClick={() => onImageView(index)} key={index}>
                                                            <img src={image.src} />
                                                        </a>
                                                    ))}
                                                </div>

                                                {view > -1 && (
                                                    <ImgsViewer
                                                        imgs={getImageList()}
                                                        currImg={view}
                                                        isOpen={true}
                                                        onClickPrev={(e) => setView(view - 1)}
                                                        onClickNext={(e) => setView(view + 1)}
                                                        onClose={() => setView(-1)}
                                                    />
                                                )}
                                            </>
                                        )}
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: data?.content,
                                            }}
                                        ></p>
                                    </td>
                                </tr>
                                {fileList?.length > 0 && (
                                    <tr>
                                        <td className="files">
                                            <ul>
                                                {fileList?.map((file, index) => (
                                                    <li key={index}>
                                                        File {parseInt(index) + 1} -&nbsp;
                                                        <a href={file.signedUrl} className="file" target="_blank">
                                                            {file.name}(size : {_U.addComma(Math.round(file.fileSize / 1000))} KBytes)
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div className="btnArea1">
                            <a href={`/bbs/${data?.code}`} className="btn1 btn_blue1">
                                List
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
